import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { isAuthPopup, isAuthTokenFrame } from './app/auth/auth-iframe';
import { routeExternalIdReturnBeforeBootstrap } from './app/auth/external-id-sign-in.service';

// DO NOT BOOT THE APP INSIDE MSAL'S SILENT-RENEWAL FRAME.
//
// redirectUri is the application root, so when MSAL renews a token silently the
// authority redirects its hidden iframe back to this page — and Angular would
// bootstrap a SECOND COMPLETE INSTANCE inside that frame, with its own MSAL,
// project restore, historical backfill and polling.
//
// The frame does not need application code: the parent polls this frame's URL
// and reads the auth response off it directly (verified in msal-browser 4.29.0,
// SilentHandler.monitorIframeForHash). Staying inert is the whole job.
//
// isAuthPopup: kept as a guard for ANY future MSAL popup landing on the root (a popup is read by
// polling, PopupClient.monitorPopupForHash). The External ID sign-in no longer uses one: it is a
// full-page redirect since 2026-10-05 (external-id-sign-in.service.ts), so today nothing opens it.
if (isAuthTokenFrame()) {
  console.log('AUTH-FRAME detected; not bootstrapping the application here');
} else if (isAuthPopup()) {
  console.log('AUTH-POPUP detected; not bootstrapping the application here');
} else {
  // A returning External ID sign-in lands on the bare origin; move it to the page it started from
  // BEFORE the router's first navigation (see the function for the measured race).
  routeExternalIdReturnBeforeBootstrap();
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}
